import { render, staticRenderFns } from "./setTall.vue?vue&type=template&id=4b64a1b5&"
import script from "./setTall.vue?vue&type=script&lang=js&"
export * from "./setTall.vue?vue&type=script&lang=js&"
import style0 from "./setTall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports